const API_URL_LOCAL = "http://192.168.1.162:53971/api/clientes";
const API_URL_PRODUCCION = "https://dashboard.apataxilleida.es/api/clientes";

// Se decide por el host desde el que se está ejecutando la aplicación.
// De esta forma el mismo build puede utilizarse en local y en producción.
const hostname = typeof window !== "undefined" ? window.location.hostname : "";
const esEntornoLocal =
  hostname === "localhost" ||
  hostname === "127.0.0.1" ||
  hostname === "::1" ||
  hostname.startsWith("192.168.");

const BASE_URL = esEntornoLocal ? API_URL_LOCAL : API_URL_PRODUCCION;

module.exports = {
  BASE_URL,
};
